import { setLegalAgreement, setLegalModal, setPersonalEmailWarningModal, setUserEmail } from "../../../../store/signUp/slice";
import { selectFetchStatus, selectLegalAgreement } from "../../../../store/signUp/selectors";
import { isBusinessEmail, validateEmail } from "../../../../utils/generalHelpers";
import { useDispatch, useSelector } from "../../../../store/store";
import { checkSignUpThunk } from "../../../../store/signUp/thunks";
import MotionWrapper from "../../../../layouts/MotionWrapper";
import { setLegalTab } from "../../../../store/general/slice";
import { LegalTab } from "../../../../store/general/types";
import { TypographyLogo } from "../../../../assets/icons";
import CheckBox from "../../../../components/CheckBox";
import Button from "../../../../components/Button";
import Input from "../../../../components/Input";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MouseEvent, useEffect, useState } from "react";
import styles from './style.module.scss';

export default function RegisterEmail() {
    const fetchStatus = useSelector(selectFetchStatus);
    const [email, setEmail] = useState('');
    const agree = useSelector(selectLegalAgreement);
    const [error, setError] = useState('');
    const [disable, setDisable] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [params, setParams] = useSearchParams();

    const memberEmail = params.get('email');

    const openLegalModal = (e: MouseEvent<HTMLSpanElement>, tab: LegalTab) => {
        e.stopPropagation();
        dispatch(setLegalTab(tab));
        dispatch(setLegalModal(true));
    };

    useEffect(() => {
        if (memberEmail) {
            setEmail(memberEmail);
            setDisable(true);
        }
    }, []);

    const next = () => {
        if (!validateEmail(email)) {
            setError('Email address is invalid.');
            return;
        }

        setError('');

        if (!isBusinessEmail(email)) {
            dispatch(setPersonalEmailWarningModal(true));
            return;
        }

        dispatch(setUserEmail(email));
        dispatch(checkSignUpThunk(email));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.head}>
                <TypographyLogo />
                <span className={styles.head_devider} />
                <span className={styles.head_title}>Sign Up</span>
            </div>
            <span className={styles.description}>
                Please sign up to continue to your account.
            </span>
            <Input
                value={email}
                onChange={setEmail}
                label='Email'
                placeholder=''
                type='email'
                error={error}
                disabled={disable}
            />
            <div className={styles.agreement} onClick={() => dispatch(setLegalAgreement(!agree))}>
                <CheckBox checked={agree} onClick={() => dispatch(setLegalAgreement(!agree))} />
                <div className={styles.agreement_text}>
                    <span>By sign up, you agree to our</span>
                    <span
                        className={styles.agreement_text_link}
                        onClick={e => openLegalModal(e, 'Employer_Terms')}
                    >
                        Terms of Use
                    </span>
                    and
                    <span
                        className={styles.agreement_text_link}
                        onClick={e => openLegalModal(e, 'Privacy_Policy')}
                    >
                        privacy policy
                    </span>
                </div>
            </div>
            <Button
                text="Next"
                onClick={next}
                className={styles.next}
                disabled={!agree || !email}
                loading={fetchStatus === 'Pending'}
            />
            <div className={styles.backToSignIn}>
                Already have an account? <span onClick={() => navigate('/signin')}>
                    sign in
                </span>
            </div>
        </MotionWrapper>
    );
};
